export function defineOnce(name: string, ctor: CustomElementConstructor): void {
  if (typeof customElements === 'undefined' || customElements.get(name)) return;
  customElements.define(name, ctor);
}
